import {Component, ViewEncapsulation} from '@angular/core';
import {LangService, LoaderService, NavigateService} from 'ngx-satoris';
import {ApiService} from 'src/app/shared/services/api.service';

@Component({
  selector: 'app-my-account',
  templateUrl: './my-account.component.html',
  styleUrls: ['./my-account.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class MyAccountComponent {

  constructor(public nav: NavigateService, public api: ApiService, public lang: LangService, private loader: LoaderService) {}

  changePassword() {
    if(!this.api.isOnline) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('no.connection')});
    } else if(this.api.userInfo && this.api.userInfo.accountName.toLowerCase().includes(this.api.userInfo.server.domain)) {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('change.password.ad')});
    } else {
      this.nav.to('change-password');
    }
  }

  history() {
    if(this.api.isOnline) {
      this.nav.to('payment-commandHistory');
    } else {
      this.loader.loading(true, {type: 'warn', message: this.lang.transform('no.connection')});
    }
  }

  wip() {
    this.loader.loading(true, {type: 'warn', message: 'WIP'}).then(() => {
      this.nav.to('my-account');
    });
  }

  disconnect() {
    this.loader.loading(true, {type: 'warn', message: 'ask.disconnect', btnLabel: 'global.yes'}).then((done) => {
      if(done) {
        this.api.signOut();
      }
    });
  }
}


